import React, { useEffect, useState, Suspense } from 'react';
import './styles/core.css';

import Loading from './Components/LoadingScreen/loading';
import routes from './routes';
import StoreX, { store } from './redux/oldStore';
import { toast, ToastContainer } from 'react-toastify';
import { EasyImage } from './Components/Tools/EasyImage';
import VersionDisplay from './Components/_Core/VersionDisplay';
import Modal from './Components/Modal/Modal';
import UserLogin, { ISignInRequest } from './Components/UserLogin/UserLogin';
import EventSessionCheckIn from './Components/SetupTools/EventSessions/EventSessionCheckIn';
import BranchSearch from './Components/Setup/Branches/BranchSearch';
import redux, { IState, ReduxMap } from './redux/redux';
import Header from './Components/PageParts/Header';
import Widget from './Components/Widgets/Widget';
import { FormatDate } from './utils/Tools';
import { ServerResponse } from './utils/Server';

const App = (props: IState) => {
  const [hideLayoutStuff, setHideLayoutStuff] = useState(false);
  const [showHud, setShowHud] = useState(true);
  const [dismissedSystemMessageIds, setDismissedSystemMessageIds] = useState<number[]>([]);

  useEffect(()=>{
    let login = StoreX.GetQueryStringValue('login');
    let quickKey = StoreX.GetQueryStringValue('quickkey');
    let checkin = StoreX.GetQueryStringValue('checkin');

    if(login && quickKey){
      const request = { key: quickKey };
      store.server.postApi<ServerResponse<ISignInRequest>>(`../Person/SignInQuick`, request).then((r) => {
            if (r.Success) {
              const data = r.Value;
              if (data.RedirectTo) {
                if (data.Message) toast.info(data.Message);
                window.location.href = data.RedirectTo;
                return;
              }
              if (data.SignedIn) {
                const finish = () => {
                  //remove query string from url
                  let url = new URL(window.location.href);
                  url.searchParams.delete('login');
                  url.searchParams.delete('quickkey');
                  url.searchParams.delete('checkin');
                  window.location.href = url.toString();
                };

                if (checkin) {
                  store.server
                    .postApi<ServerResponse<boolean>>(`../checkin/SelfCheckIn`, {})
                    .finally(finish);
                } else {
                  finish();
                }
              } else {
                redux.showLogin(true);
              }
            } else {
              toast.error(r.Message, { autoClose: false });
            }
          });
    } else if (login) {
      redux.showLogin(true);
    }


  },[]);

  useEffect(() => {
    redux.Reload();
    let hideLayout = StoreX.GetQueryStringValue('hlo');
    setHideLayoutStuff(hideLayout ? true : false);

    // if (login && StoreX.GetQueryStringValue('forgot')) {
      
    // }
    
    // if (login) {
    //   redux.showLogin(true);
    // }
  }, []);

  const visibleSystemMessages = (props.SettingsResponse?.SystemMessages || []).filter(
    (m) => !dismissedSystemMessageIds.includes(m.Id)
  );
  const systemMessagesBanner = !hideLayoutStuff && visibleSystemMessages.length > 0 && (
    <div className="system-messages no-print" role="region" aria-label="System messages">
      {visibleSystemMessages.map((m) => (
        <div
          key={m.Id}
          id={`system-message-${m.Id}`}
          className={`alert alert-dismissible alert-${(m.MessageType || 'info').toLowerCase()}`}
          role="status"
        >
          <button
            type="button"
            className="close"
            aria-label="Dismiss"
            onClick={() => setDismissedSystemMessageIds((ids) => [...ids, m.Id])}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div dangerouslySetInnerHTML={{ __html: m.MessageContent }} />
        </div>
      ))}
    </div>
  );

  return (
    <>
      {(!props.Settings) && <div className={`x-style ${hideLayoutStuff?'hide-layout-stuff':''}`}></div>}
      {props.Settings && !props.Settings.UseOldStyling ? (
        <>
          <div className={`x-style ${hideLayoutStuff?'hide-layout-stuff':''}`}>
            {!hideLayoutStuff && <div className="header-bar no-print">
              <div className="x-container">
                <Header useOld={false} state={props} />
              </div>
            </div>}

            <div className="x-color-bar">
              <div className="x-container x-body">
              <div className="main-body-wrapper">
                {/* Left Sidebar Widget */}
                {!hideLayoutStuff && props.WidgetBarLeft && props.WidgetBarLeft.length > 0 && <div  className="side-bar-widgets left-side">
                  {props.WidgetBarLeft.map((x,i)=>{
                    return <Widget state={props} type={x} key={i}/>
                  })}
                </div>}

                {/* Routes */}
                <div className='route-wrapper'>
                  <Suspense fallback={<div className="bumper">Loading...</div>}>{routes}</Suspense>
                </div>
                
                {/* Right Sidebar Widget */}
                {!hideLayoutStuff && props.WidgetBarRight && props.WidgetBarRight.length > 0 && <div  className="side-bar-widgets right-side">
                  {props.WidgetBarRight.map((x,i)=>{
                    return <Widget state={props} type={x} key={i}/>
                  })}
                </div>}
              </div>
              </div>
            </div>

            {!hideLayoutStuff && <div className="x-footer no-print">
              <div className="x-container">
                <div className="flex-between">
                  <div>
                    <h5>Brought to you by</h5>
                    <a href="https://zfairs.com">
                      <EasyImage src="https://zfairs.com/file/zFairsLight.svg" alt="zFairs logo" className="app-logo" />
                    </a>
                  </div>
                  {props.Settings && props.Settings.isHistoryContest && (
                    <div>
                      <h5>Provided by</h5>
                      <a href="https://nhd.org">
                      <EasyImage src="https://zfairs.com/file/NHD.svg" alt="NHD logo" className="app-logo-nhd" />
                      </a>
                    </div>
                  )}
                  <div>
                    <div>
                      <strong>&copy; illuminating Software LLC {new Date().getFullYear()}</strong>
                      <br />
                      zFairs {props.SettingsResponse && props.SettingsResponse.Version && <span>{props.SettingsResponse.Version}</span>}
                {' | '}
                <VersionDisplay showBuildInfo={true} />
                    </div>
                    <div>
                      <a href="https://zfairs.com/Policy/Privacy">Privacy Policy</a> | <a href="https://zfairs.com/Policy/TermsOfUse">Terms of Use</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>}

            {!hideLayoutStuff && props.Settings && <BranchSearch state={props} />}

            {props.ShowLogin && (
              <Modal
                title={props.Settings?.text.NavLogin ?? 'Sign-in'}
                setModalOpen={() => {
                  redux.showLogin(false);
                }}
                >
                <UserLogin inModal={true}/>
              </Modal>
            )}
          </div>
        </>
      ) : !hideLayoutStuff && props.Settings ? (
        <>
          <div className="backdrop"></div>
          <div className="container">
            <Header state={props} useOld={true} />
            <div className="head-room"></div>
            <div className="app-main-body">
              <Suspense fallback={<div className="bumper">Loading...</div>}>{routes}</Suspense>
            </div>
            <div className="head-room-xl"></div>
            <div className="footer primary-bg no-print">
              <div>
                <EasyImage src="https://zfairs.com/file/zFairsLight.svg" alt="zFairs logo" className="app-logo" />
              </div>
              <div>
                {props.SettingsResponse && <>{props.SettingsResponse.Version}</>}
                {' | '}
                <VersionDisplay showBuildInfo={true} />
              </div>
            </div>
          </div>

          {props.Settings && <BranchSearch state={props} />}

          {props.ShowLogin && (
            <Modal
              title={props.Settings?.text.NavLogin ?? 'Sign-in'}
              setModalOpen={() => {
                redux.showLogin(false);
              }}>
              <UserLogin inModal={true}></UserLogin>
            </Modal>
          )}
        </>
      ) : (
        <>{props.Settings && <Suspense fallback={<div className="bumper">Loading...</div>}>{routes}</Suspense>}</>
      )}
      {props.IsLoading && <Loading></Loading>}
      {props.StyleText && <style>{props.StyleText}</style>}
      {props.SettingsResponse && props.SettingsResponse.IsTest && <div className="is-test">TEST SITE</div>}
      {props.SettingsResponse && props.SettingsResponse.ArchiveAt && <div className='is-archived'>Archived Site {FormatDate(props.SettingsResponse.ArchiveAt)}</div>}
      {systemMessagesBanner}

      <ToastContainer theme="dark" autoClose={8000} draggable={true} stacked={true} />
      {props.SettingsResponse?.Settings.eventSessions && <EventSessionCheckIn />}
      {props.HudInfo && props.HudInfo.JudgingAssignments && props.HudInfo.JudgingAssignments.length > 0 && (
        <>
          {showHud && (
            <Modal setModalOpen={setShowHud} title={'HUD'}>
              <div>
                <h3>Interview Times</h3>
                Please arrive 20 minutes before your scheduled interview, incase your judges arrive early.
                <div>
                  Scheduled Times:
                  <ul>
                    {props.HudInfo.JudgingAssignments.map((x, i) => {
                      return (
                        <li className="JudingTime" key={`hud-jat-${i}`}>
                          {x.At}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </Modal>
          )}
        </>
      )}
    </>
  );
};

export default ReduxMap(App);
